{
  "otherOrganizations": "Andere Unternehmen",
  "solutionIframe": "Hauptinhalt",
  "unloadPromptMessage": "Sind Sie sicher?"
}
